import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const agentRunListQuery = graphql(`
  query AgentRuns(
    $first: Int!
    $page: Int!
    $kind: [AgentRunKind!]
    $state: [AgentRunState!]
  ) {
    agentRuns(first: $first, page: $page, kind: $kind, state: $state) {
      data {
        id
        kind
        title
        subtitle
        status
        state
        note
        created_at
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);

export type AgentRunListItem = ResultOf<
  typeof agentRunListQuery
>["agentRuns"]["data"][number];

export const agentRunQuery = graphql(`
  query AgentRun($kind: AgentRunKind!, $id: ID!) {
    agentRun(kind: $kind, id: $id) {
      id
      kind
      title
      subtitle
      status
      state
      note
      failure_reason
      created_at
      facts {
        label
        value
      }
      log {
        label
        detail
        ok
      }
      transcript {
        id
        run_number
        started_at
        messages {
          id
          role
          content
          created_at
          model
          prompt_tokens
          completion_tokens
          steps {
            id
            tool
            arguments_json
            result
            denied
          }
        }
      }
    }
  }
`);

export type AgentRunDetail = NonNullable<
  ResultOf<typeof agentRunQuery>["agentRun"]
>;

export type AgentConversation = AgentRunDetail["transcript"][number];
export type AgentMessage = AgentConversation["messages"][number];
export type AgentToolCall = AgentMessage["steps"][number];
